import { SVGProps, Ref, forwardRef } from 'react';

export const ItAccreditationSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M11.812 14.667V8.058h1.855V5.971h-1.855V2.493H9.725V5.97H7.869v2.087h1.856v6.609z"
            fill="currentColor"
        />
        <path d="M6.275 5.971H2.333v2.087h1.855v6.609h2.087z" fill="currentColor" />
        <path d="M5.232 4.232a1.45 1.45 0 1 0 0-2.899 1.45 1.45 0 0 0 0 2.899" fill="currentColor" />
    </svg>
));
ItAccreditationSize16Glyph.displayName = 'ItAccreditationSize16Glyph';
